import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-filters"
export default class extends Controller {

  export(e){
    e.preventDefault();
    let exportPath = this.element.href;
    exportPath += '?'
    const inputs = document.getElementById('filters').elements;
    for (let item of inputs) {
      if(!item.name){ continue }
      exportPath += `${item.name}=${item.value}&`
    }
    window.location.href = exportPath;
  }
}